import React , { Component} from 'react';
import {Row, Col, Button} from 'react-bootstrap';
import Auth from './Auth';
import lottie from 'lottie-web';
import animationData from '../images/lf20_v7nRH3.json';

import './Login.scss';

const auth = new Auth();
let animObj = null;

export default class Login extends Component {

    constructor(props){
        super(props);


        this.state = {
        };

    }

    componentDidMount(){
        animObj = lottie.loadAnimation({
            container: this.animBox, // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: animationData // the path to the animation json
          });
    }

    handleStop = () => {
        animObj.stop();
    }
      
    handlePlay() {
        animObj.play();
    }

    render(){
        return (
            <div id="Login">
                <Row className="login-container">
                   <Col lg={{span : 6, offset : 3}} className="login-wrapper">
                       <div style={{width: "320px", margin: '0 auto'}} ref={ ref => this.animBox = ref}></div>
                       <p className="login-title">Fetch</p>
                       <p className="login-sub">Makes Search Better</p>
                       <Button className="login-btn" variant="link" onClick={() => auth.login()}>Log me in</Button>  
                   </Col>
                </Row>

            </div>
        );
    }
}